import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { ConfigProvider, theme as antdTheme } from 'antd';
import AppLayout from './Components/AppLayout';
import TestTranslation from './Components/TestTranslation';
import Login from './Components/Login';
import Dashboard2 from './Components/Dashboard2';
import DocumentDetails2 from './Components/DocumentDetails2';
import { AuthProvider } from './Components/AuthContext';
import Settings from './Components/Settings';
import PECockpit from './Components/PECockpit';

// Global visual theme — one place lifts the whole app's look.
const patrenTheme = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    colorPrimary: '#635bff',
    colorInfo: '#635bff',
    colorLink: '#635bff',
    colorSuccess: '#12b76a',
    colorError: '#f04438',
    colorWarning: '#f79009',
    colorText: '#1b1f27',
    colorTextSecondary: '#5c6370',
    colorBorder: '#e6e8ec',
    colorBorderSecondary: '#eef0f3',
    colorBgLayout: '#f5f6f8',
    borderRadius: 8,
    borderRadiusLG: 12,
    fontFamily:
      "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 13,
    controlHeight: 36,
    boxShadow: '0 1px 2px rgba(16, 24, 40, 0.06)',
    boxShadowSecondary: '0 4px 14px rgba(16, 24, 40, 0.08)',
  },
  components: {
    Button: { fontWeight: 500, primaryShadow: '0 1px 2px rgba(99, 91, 255, 0.24)' },
    Card: { borderRadiusLG: 12 },
    Table: { headerBg: '#f7f8fa', borderColor: '#e6e8ec', rowHoverBg: '#f7f8fa' },
    Tag: { borderRadiusSM: 6 },
    Segmented: { itemSelectedBg: '#635bff', itemSelectedColor: '#ffffff' },
  },
};

const App: React.FC = () => {
  return (
    <ConfigProvider theme={patrenTheme}>
    <AuthProvider>
      <Router >
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard2" element={<AppLayout><Dashboard2 /></AppLayout>} />
          <Route path="/document2/:document_uuid" element={<AppLayout><DocumentDetails2 /></AppLayout>} />
          <Route path="/pe/:document_uuid" element={<AppLayout><PECockpit /></AppLayout>} />
          {/*<Route path="/translate" element={<AppLayout><Translate /></AppLayout>} />*/}
          <Route path="/settings" element={<AppLayout><Settings /></AppLayout>} />
          <Route path="/testtranslation" element={<AppLayout><TestTranslation /></AppLayout>} />
          {/* Add more routes as needed */}
        </Routes>
      </Router>
    </AuthProvider>
    </ConfigProvider>
  );
};

export default App;
